import { environment } from "./environments/environment";

// Use shared singleton - check if library already created one, otherwise create and share
let gbInstance;

if ((window as any)._gbSharedInstance) {
  gbInstance = (window as any)._gbSharedInstance;
} else {
  console.log('[GrowthBook App] Creating new shared instance');
  gbInstance = new (window as any)["growthbook"].GrowthBook({
    apiHost: environment.growthbookHostApi,
    clientKey: environment.growthbookClientKey,
    enableDevMode: true,
    subscribeToChanges: true,
    trackingCallback: (experiment, result) => {
    },
  });
  gbInstance.loadFeatures();
  // Expose as shared instance for library and debugging
  (window as any)._gbSharedInstance = gbInstance;
}

export let gb = gbInstance;


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/growthbook.ts